import { Link } from 'react-router-dom';
import { useState, FormEvent } from 'react';

const footerLinks = {
  hot: [
    { label: '网红翻车合集', path: '/category/wanghong-fanche' },
    { label: '明星八卦专区', path: '/category/mingxing-bagua' },
    { label: '最新吃瓜爆料', path: '/category/remen-baoliao' },
    { label: '反差视频精选', path: '/category/fancha-shipin' },
  ],
  resources: [
    { label: '吃瓜视频下载', path: '/category/remen-baoliao' },
    { label: '国产黑料合集', path: '/category/wanghong-fanche' },
    { label: '每日吃瓜推荐', path: '/' },
    { label: '吃瓜社区', path: '/about' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '联系我们', path: '/about' },
    { label: '版权声明', path: '/about' },
    { label: '隐私政策', path: '/about' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubscribe = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢关注吃瓜视频');
      setEmail('');
      return;
    }

    if (!email.trim()) return;
    setStatus('loading');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email.trim());
      const response = await fetch('https://readdy.ai/api/form/d90k0gq181e9e92u94gg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      if (response.ok) {
        setStatus('success');
        setMessage('订阅成功！每日吃瓜不错过');
        setEmail('');
      } else {
        setStatus('error');
        setMessage('订阅失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后再试');
    }
  };

  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-full">
                  <i className="ri-play-fill text-background-50 text-xl"></i>
                </span>
                <span className="font-heading text-2xl font-bold text-background-50">
                  吃瓜视频
                </span>
              </Link>
              <p className="text-background-400 text-sm leading-relaxed max-w-sm mb-6">
                全网独家吃瓜爆料视频平台。网红翻车、明星八卦、热门爆料一触即发。每日更新最新吃瓜视频，免费下载观看，吃瓜吃到饱！
              </p>
              <div className="flex items-center gap-3">
                {['ri-weibo-line', 'ri-wechat-line', 'ri-bilibili-line', 'ri-tiktok-line'].map((icon) => (
                  <a
                    key={icon}
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer"
                    rel="nofollow"
                    aria-label={icon.replace('ri-', '').replace('-line', '')}
                  >
                    <i className={`${icon} text-background-300 text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>

            {[
              { title: '热门八卦', links: footerLinks.hot },
              { title: '资源导航', links: footerLinks.resources },
              { title: '关于本站', links: footerLinks.about },
            ].map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                  {col.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-background-400 hover:text-background-50 text-sm transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6 pt-8 border-t border-background-800">
            <div className="flex items-center gap-4 flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20theater%20viewing%20scene%20with%20ambient%20lighting%2C%20abstract%20entertainment%20atmosphere%2C%20soft%20warm%20tones%2C%20cinematic%20style%2C%20editorial%20photography%2C%20professional%20composition&width=200&height=120&seq=footer-scene-01&orientation=landscape"
                alt="吃瓜视频观影场景"
                className="w-24 h-14 rounded-lg object-cover object-top flex-shrink-0"
              />
              <div>
                <p className="font-heading text-sm text-background-300">独家爆料</p>
                <p className="font-heading text-sm text-background-300">即刻观看</p>
                <p className="font-heading text-sm font-semibold text-primary-400">吃瓜吃到饱</p>
              </div>
            </div>

            <div className="flex-1 max-w-md">
              <p className="text-background-400 text-xs mb-2">订阅吃瓜视频 newsletter</p>
              <p className="text-background-500 text-xs mb-3">第一时间获取最新吃瓜爆料推送</p>
              <form
                data-readdy-form
                onSubmit={handleSubscribe}
                className="flex flex-col sm:flex-row gap-2"
              >
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="form-anti-spam"
                />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱地址"
                  required
                  className="flex-1 px-4 py-2.5 rounded-lg bg-background-800 border border-background-700 text-background-50 text-sm placeholder:text-background-500 focus:outline-none focus:border-primary-500 transition-colors"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
                >
                  {status === 'loading' ? (
                    '订阅中...'
                  ) : (
                    <>
                      订阅
                      <i className="ri-arrow-right-line text-sm"></i>
                    </>
                  )}
                </button>
              </form>
              {status === 'success' && (
                <p className="text-accent-400 text-xs mt-2">{message}</p>
              )}
              {status === 'error' && (
                <p className="text-primary-400 text-xs mt-2">{message}</p>
              )}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between pt-6 mt-6 border-t border-background-800 text-background-500 text-xs">
            <p>&copy; {new Date().getFullYear()} 吃瓜视频 All rights reserved.</p>
            <div className="flex items-center gap-4 mt-2 sm:mt-0">
              <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">服务条款</a>
              <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}